/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import '../LoyaltyConfig/index.scss';

import { useFormik } from 'formik';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { initialState } from '../../constants/adhocPoints';
import useCurrentUser from '../../hooks/useCurrentUser';
import { Business } from '../../models/User.model';
import ButtonField from '../../reusable/ButtonField';
import { TextFieldComponent } from '../../reusable/TextFieldComponent';
import ConfigService from '../../services/config.service';
import { toastMessageAction } from '../../store/action';
import { ParentLink } from '../../utils/ParentLink';
import { adHocPointsToSchema } from '../../validation/adHocPointsToSchema';
import AdHocPoints from '../Assets/adHocPoints.png';
import SettingsBreadCrumbs from '../SettingsBreadCrumbs/SettingsBreadCrumbs';

const LoyaltyPoints = () => {
  const dispatch = useDispatch();
  const [business, setBusiness] = useState(new Business());
  const user = useCurrentUser();
  const onSubmit = (data, { resetForm }) => {
    const workData = {
      password: data.newPassword,
      business: business?.name || ''
    };
    ConfigService.loylatySavePasswordConfig(workData).then(() => {
      dispatch(
        toastMessageAction({
          severity: 'success',
          message: `Password Add successfully!!!`,
          messageStatus: true
        })
      );
      resetForm();
    });
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const paramsBuId = _.parseInt(urlParams.get('bu'));
    const paramsBusiness = _(user.getBusinesses()).find(
      b => b.id === paramsBuId
    );
    if (paramsBusiness) setBusiness(paramsBusiness);
  }, [user]);

  //to handle submit form
  const formik = useFormik({
    initialValues: initialState,
    validationSchema: adHocPointsToSchema,
    onSubmit
  });
  const addUrlParams = link => {
    const urlParams = new URLSearchParams(window.location.search);
    return `${link}?bu=${urlParams.get('bu')}`;
  };
  const { values, errors, handleChange, touched, resetForm } = formik;
  return (
    <>
      <SettingsBreadCrumbs
        currentModuleName="Retensee Configuration"
        fromModuleName="Module Settings"
        isModule={true}
      />
      <div className={'retenseeContainer'}>
        <ParentLink to={addUrlParams('/loyalty-tiers')} className={'heading'}>
          Loyalty Tier
        </ParentLink>
        <ParentLink to={addUrlParams('/loyalty-config')} className={'heading'}>
          Loyalty Offer
        </ParentLink>
        <ParentLink
          to={addUrlParams('/loyalty-exception')}
          className={'heading'}
        >
          Loyalty exclusions
        </ParentLink>
        <ParentLink
          to={addUrlParams('/ad-hoc-points')}
          className={'heading activeHeading'}
        >
          Ad Hoc Points
        </ParentLink>
        <ParentLink
          to={addUrlParams('/loyalty-redeem-configuration')}
          className={'heading'}
        >
          Loyalty Redemption
        </ParentLink>
        <ParentLink
          to={addUrlParams('/referral-configuration')}
          className={'heading'}
        >
          Referral
        </ParentLink>
      </div>
      <div className={'adHocPointsContainer'}>
        <img src={AdHocPoints} alt="AdHocPoints" className="adhocPointsImage" />
        <h4 className="adHocPointsTitle">
          Set password to access Ad Hoc Points
        </h4>
        <form onSubmit={formik.handleSubmit} className="formSubmitation">
          <TextFieldComponent
            label={'New Password'}
            variant="outlined"
            onChange={handleChange}
            name={'newPassword'}
            showEyeIcon
            value={values.newPassword}
            error={touched.newPassword && errors.newPassword}
            className="textFieldStyle"
          />
          <TextFieldComponent
            label={'Confirm New Password'}
            variant="outlined"
            onChange={handleChange}
            name={'confirmNewPassword'}
            showEyeIcon
            value={values.confirmNewPassword}
            error={touched.confirmNewPassword && errors.confirmNewPassword}
            className="textFieldStyle"
          />
          <div className={'submitButtonContainer'}>
            <ButtonField
              variant="contained"
              label="Clear"
              type="button"
              onClick={() => resetForm()}
              className="clearButton"
            />
            <ButtonField
              variant="contained"
              label="Save"
              type="sumbit"
              className="saveButton"
            />
          </div>
        </form>
      </div>
    </>
  );
};
export default LoyaltyPoints;
